import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.map";

function _createForOfIteratorHelperLoose(o) { var i = 0; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } i = o[Symbol.iterator](); return i.next.bind(i); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import useAnimationFrame from '@restart/hooks/useAnimationFrame';
import React, { useCallback, useMemo, useRef, useState } from 'react';
export var DocumentOutlineContext = React.createContext(null);

function toTree(list) {
  var map = {};
  var root = {
    children: []
  };
  var parents = [];
  var last = null; // eslint-disable-next-line

  for (var _iterator = _createForOfIteratorHelperLoose(list), _step; !(_step = _iterator()).done;) {
    var item = _step.value;
    // const item = list.get(key)!;
    if (last && item.level > last.level) parents.push(last);
    if (last && item.level < last.level) parents.pop();
    last = item;
    var parent = parents[parents.length - 1];
    map[item.id] = map[item.id] || [];
    item.children = map[item.id];

    if (parent) {
      map[parent.id] = map[parent.id] || [];
      map[parent.id].push(item);
    } else root.children.push(item);
  }

  return root;
}

export default function DocumentOutlineProvider(_ref) {
  var children = _ref.children;
  var list = useRef(new Map()).current;
  var animationFrame = useAnimationFrame();

  var _useState = useState({
    children: []
  }),
      tree = _useState[0],
      setTree = _useState[1];

  var registerNode = useCallback(function (level, title, id) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (level === 1) {
      list.clear();
      return;
    }

    list.set(id, {
      level: level,
      title: title,
      id: id
    });
    animationFrame.request(function () {
      setTree(toTree(list.values()));
    });
  }, [list, animationFrame]);
  var context = useMemo(function () {
    return {
      registerNode: registerNode,
      tree: tree
    };
  }, [registerNode, tree]);
  return /*#__PURE__*/React.createElement(DocumentOutlineContext.Provider, {
    value: context
  }, children);
}